/**
 * Namespacing for browser localStorage keys (BON-1461).
 *
 * Staging and production are separate origins, so their localStorage is already separate —
 * the prefix exists to keep the keys distinguishable when several environments genuinely do
 * share an origin (same host behind a path, or a future single-domain setup). It does NOT
 * affect the auth cookies, which the backend scopes by domain.
 *
 * Set via the build-time env var `VITE_STORAGE_PREFIX`; empty (production) keeps the bare keys
 * so existing users don't silently lose their persisted filters.
 */

/** Pure form — the prefix is a parameter so this stays testable without the build env. */
export function prefixStorageKey(prefix: string | undefined, name: string): string {
  const trimmed = prefix?.trim()
  return trimmed ? `${trimmed}:${name}` : name
}

/** Applies the prefix configured for this build. */
export function storageKey(name: string): string {
  return prefixStorageKey(import.meta.env.VITE_STORAGE_PREFIX, name)
}
